import React, { FC, useState } from 'react';
import { Question } from '../models/Question';
import './QuestionCard.css';

interface QuestionProps {
  index: number
  data: Question
  handleAnswerClick: (questionIndex: number, selectedOptionId: number) => void;
}

const QuestionCard: FC<QuestionProps> = ({index, data, handleAnswerClick }) => {
  const [selectedButton, setSelectedButton] = useState<number>(-1);

  const handleButtonClick = (buttonId: number, questionIndex: number, optionId: number) => {
    if(selectedButton !== buttonId) {
      setSelectedButton(buttonId)
      handleAnswerClick(questionIndex, optionId)
    } else {
      setSelectedButton(-1)
      handleAnswerClick(questionIndex, -1)
    }
  };

  return (
    <div className="question-card">
      <div className="question-card-body">
        <div className="question-card-title">
          <span className="question-number">Spørgsmål {index + 1}.</span> {data.text}
        </div>
        <div className="question-options">
          {data.options.map((option, i) => (
            <button 
              key={i} 
              className={`question-option ${selectedButton === i ? 'selected' : ''}`}
              onClick={() => handleButtonClick(i, index, option.id)}
            >
              {option.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;
